<template>
  <div>
    <section class="hero">
      <div class="hero__copy">
        <p class="eyebrow">Luxury Made Affordable</p>
        <h1>The perfume you<br><em>never forgot.</em></h1>
        <p class="hero__description">
          A first date. A school corridor. Your father's cupboard before a wedding.
          We recreate the legendary fragrances behind those memories, so wearing
          one no longer costs a month's salary.
        </p>
        <div class="hero__actions">
          <button type="button" class="primary-action" @click="$emit('shop')">Explore the collection</button>
          <a href="https://www.instagram.com/cher_goa" target="_blank" rel="noopener">Follow @cher_goa</a>
        </div>
        <div class="hero__trust">
          <span><v-icon size="18">mdi-map-marker-outline</v-icon> Made in Goa</span>
          <span><v-icon size="18">mdi-flask-outline</v-icon> Hand blended</span>
          <span><v-icon size="18">mdi-leaf</v-icon> Long lasting</span>
        </div>
      </div>

      <div class="hero__art" aria-label="CHER signature fragrance">
        <div class="hero__halo"></div>
        <PerfumeBottle name="Signature Collection" meta="Eau de Parfum" :scale="2" />
        <div class="hero__caption">
          <span>01</span>
          <p><strong>Signature blends</strong><br>made for your everyday ritual</p>
        </div>
      </div>
    </section>

    <section class="value-strip">
      <p>Choose your ritual</p>
      <div><strong>Perfume</strong><span>A radiant spray in 10 ml or 50 ml</span></div>
      <div><strong>Ittar</strong><span>A rich, concentrated 6 ml roll-on</span></div>
      <div><strong>Car aromas</strong><span>Your favourite scent, on the road</span></div>
    </section>

    <section class="story">
      <div class="story__title">
        <p class="eyebrow">Why CHER exists</p>
        <h2>The originals cost<br>a fortune. The<br>memory shouldn't.</h2>
      </div>
      <div class="story__copy">
        <p>Somewhere along the way, the scents we grew up admiring became things you save up for.</p>
        <p>We study those classics and rebuild them note for note, here in Goa. Same trail, same turned heads, a fraction of the price.</p>
        <button type="button" @click="$emit('shop')">Find yours <span>→</span></button>
      </div>
    </section>
  </div>
</template>

<script>
import PerfumeBottle from './PerfumeBottle.vue'

export default {
  name: 'HomeTab',
  components: { PerfumeBottle }
}
</script>

<style scoped>
.hero { min-height: 760px; display: grid; grid-template-columns: 1.03fr .97fr; background: #f5f0e8; }
.hero__copy { display: flex; flex-direction: column; justify-content: center; padding: 100px max(40px, 7vw) 70px; }
.eyebrow { margin: 0 0 24px; color: #9f633e; font-size: 11px; font-weight: 800; letter-spacing: 2.2px; text-transform: uppercase; }
h1, h2 { margin: 0; color: #211e1a; font-family: Georgia, serif; font-weight: 400; }
h1 { font-size: clamp(50px, 6.3vw, 94px); line-height: .96; letter-spacing: -3px; }
h1 em { color: #9c6848; font-weight: 400; }
.hero__description { max-width: 530px; margin: 33px 0; color: #655d54; font-size: 16px; line-height: 1.8; }
.hero__actions { display: flex; align-items: center; gap: 28px; }
.primary-action { padding: 15px 22px; border: 0; border-radius: 4px; color: #fff; background: #26221d; font-size: 13px; font-weight: 700; }
.hero__actions a { color: #3c3731; font-size: 12px; font-weight: 700; text-decoration: none; border-bottom: 1px solid #a89c8f; }
.hero__trust { display: flex; gap: 25px; margin-top: 70px; color: #756b60; font-size: 11px; }
.hero__trust span { display: flex; align-items: center; gap: 5px; }
.hero__art { position: relative; display: grid; place-items: center; overflow: hidden; background: linear-gradient(145deg, #c5b19b, #8b6c54); }
.hero__art::before { content: ''; position: absolute; inset: 0; background: radial-gradient(circle at 70% 25%, rgba(255,255,255,.3), transparent 31%); }
.hero__halo { position: absolute; width: min(38vw, 520px); height: min(38vw, 520px); border: 1px solid rgba(255,255,255,.45); border-radius: 50%; }
.hero__art .bottle { z-index: 1; }
.hero__caption { position: absolute; right: 8%; bottom: 6%; display: flex; gap: 13px; color: rgba(255,255,255,.82); font-size: 11px; line-height: 1.5; }
.hero__caption > span { font-family: Georgia, serif; font-size: 28px; }
.hero__caption p { margin: 0; }
.value-strip { display: grid; grid-template-columns: .7fr repeat(3, 1fr); gap: 28px; padding: 34px 6vw; color: #ebe6df; background: #26221d; }
.value-strip p { margin: 0; color: #a99c8f; font-family: Georgia, serif; font-style: italic; }
.value-strip div { display: flex; flex-direction: column; gap: 5px; }
.value-strip strong { font-family: Georgia, serif; font-weight: 400; }
.value-strip span { color: #a99f94; font-size: 10px; }
.story { max-width: 1140px; display: grid; grid-template-columns: 1fr 1fr; gap: 90px; margin: 0 auto; padding: 110px 28px; }
.story h2 { font-size: clamp(42px, 5vw, 68px); line-height: 1.05; }
.story__copy { padding-top: 34px; color: #696057; font-family: Georgia, serif; font-size: 19px; line-height: 1.65; }
.story__copy button { margin-top: 15px; padding: 0 0 6px; border: 0; border-bottom: 1px solid #9d9185; background: transparent; color: #312c26; font-family: Inter, sans-serif; font-size: 12px; font-weight: 800; }
.story__copy button span { margin-left: 12px; }
@media (max-width: 850px) {
  .hero { grid-template-columns: 1fr; }
  .hero__copy { min-height: 650px; padding: 90px 25px 55px; }
  .hero__art { min-height: 610px; }
  .hero__halo { width: 78vw; height: 78vw; }
  .value-strip { grid-template-columns: 1fr; }
  .story { grid-template-columns: 1fr; gap: 20px; padding: 75px 24px; }
}
@media (max-width: 520px) {
  h1 { letter-spacing: -2px; }
  .hero__actions { align-items: flex-start; flex-direction: column; }
  .hero__trust { flex-wrap: wrap; gap: 14px; margin-top: 45px; }
  .hero__art { min-height: 500px; }
  .hero__art .bottle { --s: 1.45 !important; }
}
</style>